import React from 'react';
import { useTheme } from '@mui/material';
import { Button, Stack, Typography, FormControlLabel, FormLabel, FormGroup, Switch } from '@mui/material';
import StandardDialog, { StandardDialogActions } from '../../../Modals/StandardDialog';
import { SiteCloudStatus, Survey } from '../../../../interfaces/survey.interface';

type AcceptAssessmentDialogProps = {
  isOpen: boolean;
  handleClose: () => void;
  onConfirm: () => void;
  siteCloudStatus: SiteCloudStatus;
  surveys: Survey[];
};

const AcceptAssessmentDialog = ({ isOpen, handleClose, onConfirm, siteCloudStatus, surveys }: AcceptAssessmentDialogProps) => {
  const theme = useTheme();
  const commonTypographyStyles = {
    marginBottom: '15px',
    color: theme.palette.customThemeColors?.darkGrey,
    fontSize: '14px',
  };

  return (
    <StandardDialog
      title={'Accept Assessment?'}
      handleClose={handleClose}
      isOpen={isOpen}
    >
      <Typography sx={{ ...commonTypographyStyles, fontSize: '16px' }}>
        Are you sure you want to accept this assessment?
      </Typography>
      <Typography sx={commonTypographyStyles}>
        By clicking &quot;ACCEPT&quot; you confirm that you have reviewed the Scoping Baseline and Questionnaire answers.
      </Typography>
      <Typography sx={commonTypographyStyles}>
        Please remind the Service Provider to make any needed changes after you &quot;Accept&quot; their assessment, before you click on &quot;Begin Assessment&quot;. This will be the only opportunity for the Service Providers to update their questionnaire answers.
      </Typography>
      <Typography sx={commonTypographyStyles}>
        Please note that additional questions may be exposed or hidden as part of the adjustment process.
      </Typography>
      <Stack spacing={2} justifyContent="flex-start" alignItems="flex-start">
        <FormGroup sx={{ marginLeft: '7px' }}>
          <FormLabel component="legend">Scope</FormLabel>
          <FormControlLabel
            labelPlacement="end"
            disabled
            control={<Switch checked={siteCloudStatus.site || siteCloudStatus.both} />}
            label={
              <Typography sx={{ ...commonTypographyStyles, marginBottom: 0 }}>
                {surveys[0]?.site ? 'Site' : 'On-Prem'}
              </Typography>
            }
          />
          <FormControlLabel
            labelPlacement="end"
            disabled
            control={<Switch checked={siteCloudStatus.cloud || siteCloudStatus.both} />}
            label={
              <Typography sx={{ ...commonTypographyStyles, marginBottom: 0 }}>
                Cloud
              </Typography>
            }
          />
        </FormGroup>
      </Stack>
      <StandardDialogActions>
        <Button variant='outlined' onClick={handleClose}>Cancel</Button>
        <Button variant='contained' color='primary' onClick={onConfirm}>Accept</Button>
      </StandardDialogActions>
    </StandardDialog>
  );
};

export default AcceptAssessmentDialog;
